// Copyright (C) 2018-2025 Skylark Drones

export { SVG_ICONS, PROJECT_TYPE_LOGOS } from './icon-paths'

export const LATEST_DMO_RELEASE = process.env.VUE_APP_RELEASE_VERSION

export const BASE_API_HOST_URL = process.env.VUE_APP_BASE_API_HOST_URL

export const APP_VERSIONS_MIN_THRESHOLD_PERCENT = parseFloat(
  process.env.VUE_APP_APP_VERSIONS_MIN_THRESHOLD_PERCENT
)

export const MAX_MRU_CAMERAS = 5

export const DEV_TOOLS = process.env.VUE_APP_DEV_TOOLS === 'true'

export const NEW_STREAM_SCREEN =
  process.env.VUE_APP_NEW_STREAM_SCREEN === 'true'

export const BASE_EVENT_GATEWAY_HOST_URL =
  process.env.VUE_APP_BASE_EVENT_GATEWAY_HOST_URL

export const AGORA_APPID = process.env.VUE_APP_AGORA_APPID
export const AGORA_TOKEN = process.env.VUE_APP_AGORA_TOKEN
export const MQTT_BROKER_URL = process.env.VUE_APP_MQTT_BROKER_URL

export const OTP_EXPIRY = 3 * 60

export const RAZORPAY_KEY_ID = process.env.VUE_APP_RAZORPAY_KEY_ID

export const SELF_SERVE_ENABLED =
  process.env.VUE_APP_SELF_SERVE_ENABLED === 'true'

export const SHOW_DOCK_ALERT = process.env.VUE_APP_SHOW_DOCK_ALERT === 'true'
